import { SwipeableDrawer } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import DownChevron from "../../assets/icons-svg/down-chevron.svg";
import UpChevron from "../../assets/icons-svg/up-chevron.svg";
import { ONBOARDING_STEPS, ROUTES } from "../constants/user-info.const";
interface SwipeAttribute {
  swipeSection: string;
  onBoardingSteps: [];
}
function SwipeableDrawerSection(props: SwipeAttribute) {
  const { swipeSection, onBoardingSteps } = props;
  const [state, setState]: any = React.useState({
    top: false,
    bottom: false,
  });
  const swipeIcon: string =
    swipeSection === "top" ? "swipeTop__Icon" : "swipeBottom__Icon";
  const swipeArray = swipeSection === "top" ? ["top"] : ["bottom"];
  const location = useLocation();
  const displayCurrentText = (route: string) => {
    const currentPath = location.pathname;
    if (currentPath === route) {
      return <span>(Current)</span>;
    }
  };
  const completedStep = (step): string => {
    if (!onBoardingSteps) return "";
    return onBoardingSteps[step] ? "completed-step" : "";
  };
  const toggleDrawer = (anchor: string, open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const activatedClass = (path: string): string => {
    return location.pathname === path ? "active-route" : "";
  };

  const list = (anchor: string) => (
    <div
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="toolbar swipe__section">
        {swipeSection === "bottom" && (
          <>
            <div className="swipe__section--topLine swipe__section--line"></div>
            <h4 className="swipeBottom__drawer--header"> Sections </h4>
          </>
        )}
        <div className="toolbar--leftMenu">
          <ul className="toolbar--leftMenu__items">
            <li
              className={
                activatedClass(ROUTES.personalInfo) +
                " " +
                completedStep(ONBOARDING_STEPS.personalInfo)
              }
            >
              Personal Info
              {displayCurrentText(ROUTES.personalInfo)}
            </li>
            <li
              className={
                activatedClass(ROUTES.homeAddress) +
                " " +
                completedStep(ONBOARDING_STEPS.homeAddress)
              }
            >
              Home Address
              {displayCurrentText(ROUTES.homeAddress)}
            </li>
            <li
              className={
                activatedClass(ROUTES.federalTaxes) +
                " " +
                completedStep(ONBOARDING_STEPS.federalTaxes)
              }
            >
              Federal Taxes
              {displayCurrentText(ROUTES.federalTaxes)}
            </li>
            <li
              className={
                activatedClass(ROUTES.stateTaxes) +
                " " +
                completedStep(ONBOARDING_STEPS.stateTaxes)
              }
            >
              State Taxes
              {displayCurrentText(ROUTES.stateTaxes)}
            </li>
            <li
              className={
                activatedClass(ROUTES.paymentMethod) +
                " " +
                completedStep(ONBOARDING_STEPS.paymentMethod)
              }
            >
              Payment Method
              {displayCurrentText(ROUTES.paymentMethod)}
            </li>
            <li
              className={
                activatedClass(ROUTES.reviewInfo) +
                " " +
                completedStep(ONBOARDING_STEPS.reviewInfo)
              }
            >
              Review Info
              {displayCurrentText(ROUTES.reviewInfo)}
            </li>
            <li
              className={
                activatedClass(ROUTES.termsOfService) +
                " " +
                completedStep(ONBOARDING_STEPS.termsOfService)
              }
            >
              Terms of Service
              {displayCurrentText(ROUTES.termsOfService)}
            </li>
            <li
              className={
                activatedClass(ROUTES.eSign) +
                " " +
                completedStep(ONBOARDING_STEPS.eSign)
              }
            >
              E-Sign
              {displayCurrentText(ROUTES.eSign)}
            </li>
          </ul>
        </div>

        {swipeSection === "top" && (
          <>
            <h4 className="swipeTop__drawer--header"> Sections </h4>
            <div className="swipe__section--bottomLine swipe__section--line"></div>
          </>
        )}
      </div>
    </div>
  );
  return (
    <>
      {swipeArray.map((anchor: any) => (
        <React.Fragment key={anchor}>
          {swipeSection === "top" && (
            <img
              src={DownChevron}
              alt="Swipe Down"
              onClick={toggleDrawer(anchor, true)}
              className={swipeIcon}
            />
          )}
          {swipeSection === "bottom" && (
            <img
              src={UpChevron}
              alt="Swipe Up"
              onClick={toggleDrawer(anchor, true)}
              className={swipeIcon}
            /> 
          )}
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            className={
              swipeSection === "top"
                ? "swipeTop__drawer"
                : "swipeBottom__drawer"
            }
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </>
  );
}
const mapStateToProps = (state) => ({
  onBoardingSteps: state.steps.onBoardingSteps,
});
export default connect(mapStateToProps)(SwipeableDrawerSection);
